(() => {
  'use strict';

  const STYLE_ID = 'xylo-rubik-mobile-grid-fix';

  function applyRubikMobileFix() {
    if (window.innerWidth > 749) return;

    const rubikElements = document.querySelectorAll(
      'quick-add-dialog#quick-add-dialog #quick-add-modal-content rubik-combined-listings'
    );

    rubikElements.forEach((rubik) => {
      const shadowRoot = rubik.shadowRoot;

      if (!shadowRoot) return;

      const wrapper = rubik.closest('.rcl-swatch-wrapper');
      const dialog = rubik.closest('quick-add-dialog');
      const productDetails =
        rubik.closest('.product-details') ||
        dialog?.querySelector('.product-details');

      /*
       * Rubik ke outer block aur uske parents ko
       * Quick Add ki full width deta hai.
       */
      if (wrapper) {
        wrapper.style.setProperty('display', 'block', 'important');
        wrapper.style.setProperty('width', '100%', 'important');
        wrapper.style.setProperty('max-width', '100%', 'important');
        wrapper.style.setProperty('min-width', '0', 'important');
        wrapper.style.setProperty('inline-size', '100%', 'important');
        wrapper.style.setProperty('grid-column', '1 / -1', 'important');
        wrapper.style.setProperty('align-self', 'stretch', 'important');
        wrapper.style.setProperty('overflow', 'visible', 'important');
        wrapper.style.setProperty('contain', 'none', 'important');

        const parent = wrapper.parentElement;

        if (parent) {
          parent.style.setProperty('width', '100%', 'important');
          parent.style.setProperty('max-width', '100%', 'important');
          parent.style.setProperty('min-width', '0', 'important');
          parent.style.setProperty('grid-column', '1 / -1', 'important');
          parent.style.setProperty('align-self', 'stretch', 'important');
        }
      }

      rubik.style.setProperty('display', 'block', 'important');
      rubik.style.setProperty('width', '100%', 'important');
      rubik.style.setProperty('max-width', '100%', 'important');
      rubik.style.setProperty('min-width', '0', 'important');
      rubik.style.setProperty('inline-size', '100%', 'important');

      /*
       * Product details ki actual available width apply karta hai.
       */
      if (wrapper && productDetails) {
        const detailsStyles = window.getComputedStyle(productDetails);

        const availableWidth =
          productDetails.clientWidth -
          parseFloat(detailsStyles.paddingLeft || 0) -
          parseFloat(detailsStyles.paddingRight || 0);

        if (availableWidth > 200) {
          wrapper.style.setProperty(
            'width',
            `${availableWidth}px`,
            'important'
          );

          wrapper.style.setProperty(
            'max-width',
            `${availableWidth}px`,
            'important'
          );
        }
      }

      if (shadowRoot.getElementById(STYLE_ID)) return;

      const style = document.createElement('style');

      style.id = STYLE_ID;

      style.textContent = `
        @media screen and (max-width: 749px) {
          :host {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            inline-size: 100% !important;
            overflow: visible !important;

            --rcl-swatch-width: auto !important;
            --rcl-grid-gap: 6px !important;
            --rcl-grid-padding-inline: 0px !important;
            --rcl-grid-padding-block: 4px !important;
          }

          .rcl,
          .rcl__group {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            overflow: visible !important;
            box-sizing: border-box !important;
          }

          .rcl__group-label {
            display: block !important;
            width: 100% !important;
            margin: 0 0 10px !important;
            padding: 0 !important;
          }

          .rcl__grid {
            display: grid !important;
            grid-template-columns:
              repeat(auto-fit, minmax(40px, 1fr)) !important;
            gap: 6px !important;

            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;

            margin: 0 !important;
            padding: 2px 0 !important;

            overflow: visible !important;
            box-sizing: border-box !important;
          }

          .rcl__swatch {
            display: block !important;
            width: 100% !important;
            min-width: 0 !important;
            max-width: none !important;

            margin: 0 !important;
            padding: 0 !important;
            box-sizing: border-box !important;
          }

          .rcl__swatch-media {
            display: block !important;
            width: 100% !important;
            aspect-ratio: 1 / 1 !important;
            overflow: hidden !important;
            box-sizing: border-box !important;
          }

          .rcl__swatch-image {
            display: block !important;
            width: 100% !important;
            height: 100% !important;
            object-fit: contain !important;
          }

          .rcl__swatch-info {
            display: block !important;
            width: 100% !important;
            min-width: 0 !important;
            padding: 3px 1px !important;
            text-align: center !important;
            box-sizing: border-box !important;
          }

          .rcl__swatch-label {
            display: block !important;
            width: 100% !important;

            overflow: hidden !important;
            white-space: nowrap !important;
            text-overflow: ellipsis !important;

            font-size: 7px !important;
            line-height: 1.2 !important;
            text-align: center !important;
          }

          .rcl__swatch-price {
            display: none !important;
          }
        }
      `;

      shadowRoot.appendChild(style);
    });
  }

  function scheduleFix() {
    applyRubikMobileFix();

    [100, 300, 700, 1200].forEach((delay) => {
      window.setTimeout(applyRubikMobileFix, delay);
    });
  }

  scheduleFix();

  const observer = new MutationObserver(() => {
    scheduleFix();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener(
    'xylo:rubik-quick-add:changed',
    scheduleFix
  );

  window.addEventListener('resize', scheduleFix);
})();